import type { PropsWithChildren } from "react";

interface Props {
  label?: string | null;
  description?: string | null;
}

export const FieldShell = ({
  label,
  description,
  children,
}: PropsWithChildren<Props>) => (
  <div className="space-y-2">
    {label && <h3 className="block font-medium text-foreground text-sm">{label}</h3>}
    {description && <p className="text-muted-foreground text-xs">{description}</p>}
    {children}
  </div>
);
